import EditedLabel from './EditedLabel';

export default EditedLabel;
